import {ErrorType} from "types/error";
import {ErrorPage as ErrorPageUI} from "@pinch-financial/pinch-ui-components";
import {useDispatch} from "react-redux";
import {signOut} from "~/store/actions/auth.action";
import {Typography, Button} from "@mui/material";
import {useTranslation} from "react-i18next";

interface Props {
  containerRef?: React.RefObject<HTMLDivElement>;
}

const ApplicationInactiveErrorPage = ({containerRef}: Props) => {
  const {t} = useTranslation("", {keyPrefix: "ApplicationInactiveErrorPage"});

  const dispatch = useDispatch();

  return (
    <ErrorPageUI
      containerRef={containerRef}
      title={t("title")}
      message={
        <div>
          <Typography>{t("body")}</Typography>
          <Button onClick={() => dispatch(signOut())}>{t("restartButton")}</Button>
        </div>
      }
    />
  );
};

export default ApplicationInactiveErrorPage;
